import { Divider } from '@scuf/common';
import { WarrantyConsultModal } from 'components';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function WarrantyConsultPage() {
    const { t } = useTranslation(['pages']);

    useEffect(() => {
        document.title = t('pages:warrantyConsult');
    }, []);

    usePreventClickjacking();

    return (
        <div className="container">
            <div className="contentPageContainer">
                <div className="form3Columns">
                    <h2>{t('pages:warrantyConsult')}</h2>
                    <Divider />
                    <WarrantyConsultModal />
                </div>
            </div>
        </div>
    );
}

export default WarrantyConsultPage;
